export function getLocalStorage(name: string): string | undefined {
  if (typeof window === "undefined") {
    return undefined
  }

  try {
    const value = window.localStorage.getItem(name)
    return value !== null ? value : undefined
  } catch (error) {
    console.error("Error reading from localStorage:", error)
    return undefined
  }
}

export function setLocalStorage(name: string, value: string): void {
  if (typeof window === "undefined") {
    return
  }

  try {
    window.localStorage.setItem(name, value)
  } catch (error) {
    console.error("Error setting localStorage:", error)
  }
}

export function deleteLocalStorage(name: string): void {
  if (typeof window === "undefined") {
    return
  }

  try {
    window.localStorage.removeItem(name)
  } catch (error) {
    console.error("Error deleting from localStorage:", error)
  }
}